import { memo, useState } from "react";
import { handleModal } from "../../redux/actions/modals";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toastConfig } from "../../redux/actions/toast";
import { getFundsWithdrawalCancellation } from "../../redux/actions/funds";




const CancellationConfirmationModal = ({ transactionDetails }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);

    const onHide = () => {
        dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false }]));
    };
    const [isDisableConfirm, setIsDisableConfirm] = useState(false);
    const handleWithdrawalCancel = async (type) => {
        setIsDisableConfirm(true);
        if (type === "NO") {
            dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false }]));
        } else {
            await dispatch(getFundsWithdrawalCancellation({ TxnRefNo: transactionDetails?.nTxnRefNo, amount: transactionDetails?.nAmount, productId: transactionDetails?.sProductId }))?.then(() => {
                dispatch(handleModal([{ "SUCCESS_MODAL": true }]));
                dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false }]));
            })?.catch((error) => {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Ooop!! Please try again...` }));
                dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false }]));
                dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false }]));
            });
        }
        await setIsDisableConfirm(false);
    };

    return (
        <BzModal size='sm' show={modals['TRANSACTION_CANCEL_CONFIRMATION_MODAL']} onHide={onHide} data-testid="transaction-cancel-confirmation-modal">
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div data-testid="transaction-cancel-modal-title" className='font-medium font-size4 color-text'>Withdraw Cancel</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div data-testid="transaction-cancel-modal-close-icon" className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <div data-testid="transaction-cancel-modal-message" className='font-regular font-size4 color-text'>Are you sure you want to cancel request?</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='m-0 p-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={8} className='d-flex align-items-center'>
                            <BzButton data-testid="transaction-cancel-modal-no-button"   className='btn btn-md btn-block btn-outline me-3' disabled={isDisableConfirm} onClick={() => handleWithdrawalCancel("NO")}>No</BzButton>
                            <BzButton data-testid="transaction-cancel-modal-yes-button"  className='btn btn-md btn-block btn-primary' disabled={isDisableConfirm} onClick={() => handleWithdrawalCancel("YES")}>Yes</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(CancellationConfirmationModal);